import React, { useState, useEffect } from 'react';
import MemberDetailsForm from './components/MemberDetailsForm';
import FormClosedPage from './components/FormClosedPage';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  const IS_FORM_OPEN = true; // Change this to false to close the form
  const [currentHash, setCurrentHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (currentHash === '#/eb' || currentHash === '#/eb/') {
    return <AdminPanel />;
  }

  return (
    <div className="App">
      {IS_FORM_OPEN ? (
        <MemberDetailsForm />
      ) : (
        <FormClosedPage />
      )}
    </div>
  );
}

export default App;
